<template>
  <div class="sidebar-page-wrapper">
    <div
      class="sidebar-menu-bg"
      v-if="menuBg && $root.screenWidth > 550"
      :style="{ 'background-image': `url(${menuBg})` }"
    ></div>
    <div
      class="sidebar"
      :style="{
        'background-image': $root.screenWidth <= 550 ? `url(${menuBg})` : ''
      }"
    >
      <el-menu
        router
        :default-active="$route.path"
        class="sidebar-menu"
        :mode="$root.screenWidth > 550 ? 'vertical' : 'horizontal'"
      >
        <el-menu-item
          index="/patients/monitor"
          v-if="p('Patients.Monitor.View')"
        >
          <span slot="title">{{ $t('text.patient').toUpperCase() }}</span>
        </el-menu-item>
        <el-submenu
          index="/patients/voiding-chart"
          v-if="
            p('Patients.Charts Module.Voiding Chart.View') ||
              p('Patients.Charts Module.Pad Fill Profile Chart.View') ||
              p('Patients.Charts Module.Smartz Devices Chart.View') ||
              p('Patients.Charts Module.Body Position Chart.View') ||
              p('Patients.Charts Module.Event Chart.View')
          "
        >
          <template slot="title">
            <span>{{ $t('text.charts').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/patients/voiding-chart"
            v-if="p('Patients.Charts Module.Voiding Chart.View')"
            >{{ $t('text.void_chart') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/smartz-events-chart"
            v-if="p('Patients.Charts Module.Event Chart.View')"
            v-html="$t('text.events')"
          ></el-menu-item>
          <el-menu-item
            index="/patients/pad-fill-profile-chart"
            v-if="p('Patients.Charts Module.Pad Fill Profile Chart.View')"
            >{{ $t('text.pad_fill_profile') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/position-chart"
            v-if="p('Patients.Charts Module.Body Position Chart.View')"
            >{{ $t('text.body_position') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/smartz-devices"
            v-if="p('Patients.Charts Module.Smartz Devices Chart.View')"
            >{{ $t('text.smartz_devices') }}</el-menu-item
          >
        </el-submenu>
        <el-submenu
          index="/patients/pad-fill-profile-goal"
          v-if="
            p('Patients.Goals Module.Pad Fill Profile.View') ||
              p('Patients.Goals Module.Skin Care.View') ||
              p('Patients.Goals Module.Position.View') ||
              p('Patients.Goals Module.Temperature.View') ||
              p('Patients.Goals Module.Fall.View')
          "
        >
          <template slot="title">
            <span>{{ $t('text.goal').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/patients/position-goal"
            :class="{
              'goal-active':
                goal.IsDayPosGoalEnabled || goal.IsNightPosGoalEnabled
            }"
            v-if="p('Patients.Goals Module.Position.View')"
            >{{
              this.$store.state.locale.currentLocale === 'de'
                ? $t('text.body_position_goal_for_de')
                : $t('text.body_position')
            }}</el-menu-item
          >
          <el-menu-item
            index="/patients/skin-care-goal"
            :class="{
              'goal-active':
                goal.IsDayPadGoalEnabled || goal.IsNightPadGoalEnabled
            }"
            v-if="p('Patients.Goals Module.Skin Care.View')"
            >{{ $t('text.skin_care') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/pad-fill-profile-goal"
            :class="{
              'goal-active':
                goal.IsDayGoalVolEnabled || goal.IsNightGoalVolEnabled
            }"
            v-if="p('Patients.Goals Module.Pad Fill Profile.View')"
            >{{ $t('text.pad_fill_profile') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/temperature-goal"
            :class="{ 'goal-active': goal.IsTempGoalEnabled }"
            v-if="p('Patients.Goals Module.Temperature.View')"
            >{{ $t('text.temperature') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/fall-detection-goal"
            :class="{ 'goal-active': goal.IsFallGoalEnabled }"
            v-if="p('Patients.Goals Module.Fall.View')"
            >{{ $t('text.falls') }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
    <div class="sidebar-type-page-content">
      <PatientFilter v-if="$route.path !== '/patients/landing'" />
      <Helper v-if="$route.path !== '/patients/landing'" />
      <router-view ref="content" />
    </div>
  </div>
</template>

<script>
import Helper from '@/components/Helper.vue'
import PatientFilter from '@/components/dashboard/PatientFilter.vue'
export default {
  components: {
    Helper,
    PatientFilter
  },
  computed: {
    menuBg() {
      return this.$store.state.customization.menuBg
    },
    goal() {
      return this.$store.state.patient.selectedPatientGoal
    }
  },
  mounted() {
    this.$store.dispatch('patient/getSelectedPatientGoal')
    this.$store.dispatch('patient/getSelectedPatientHistoryData')
  },
  watch: {
    '$store.state.patient.selectedPatient.patientId'() {
      this.$store.dispatch('patient/getSelectedPatientGoal')
      this.$store.dispatch('patient/getSelectedPatientHistoryData')
    }
  }
}
</script>
